import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Paginacion({ pagina, totalPaginas, total, onCambiarPagina }) {
  if (totalPaginas <= 1) return null;

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between px-3 py-3 border-t text-sm text-slate-500">
      <span>{total} {total === 1 ? 'resultado' : 'resultados'}</span>
      <div className="flex items-center gap-3">
        <button
          onClick={() => onCambiarPagina(pagina - 1)}
          disabled={pagina <= 1}
          className="p-1.5 rounded-md border text-slate-500 hover:bg-slate-50 disabled:opacity-40 disabled:hover:bg-transparent"
        >
          <ChevronLeft size={16} />
        </button>
        <span>Página {pagina} de {totalPaginas}</span>
        <button
          onClick={() => onCambiarPagina(pagina + 1)}
          disabled={pagina >= totalPaginas}
          className="p-1.5 rounded-md border text-slate-500 hover:bg-slate-50 disabled:opacity-40 disabled:hover:bg-transparent"
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
